import React, { useEffect, useState } from 'react';
import GalleryTab from '../components/Gallery';
import Footer from '../components/footer';
import Header from '../components/header';
import { Link } from 'react-router-dom';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const Gallery = () => {
    useEffect(() => {
        document.title = ":: Services & Products | Adber Infra India Pvt. Ltd. ::";
    }, []);
    const [activeTab] = useState('football');

    const footballGallery = [
        {
            "imgSrc": "../assets/images/gallery/2.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/3.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/4.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/5.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/6.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/7.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/8.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/9.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/10.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/11.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/12.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/13.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/14.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/15.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/16.jpg",
            "altText": "Sanjay Sports Academy"
        }
    ];

    const cricketGallery = [
        {
            "imgSrc": "../assets/images/gallery/gallery-1.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-2.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-3.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-4.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-5.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-6.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-5.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-6.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-7.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-8.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-9.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-10.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-11.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-12.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-13.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-14.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-15.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-015.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-16.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-17.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-18.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-19.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-20.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-21.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-22.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-23.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-24.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-25.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-26.jpg",
            "altText": "Sanjay Sports Academy"
        }
        ,
        {
            "imgSrc": "../assets/images/gallery/gallery-27.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-28.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-29.jpg",
            "altText": "Sanjay Sports Academy"
        },
        {
            "imgSrc": "../assets/images/gallery/gallery-30.jpg",
            "altText": "Sanjay Sports Academy"
        }
    ];

    return (
        <div>
            <Header />
            {/* Inner Page Banner */}
            <section className="inner-page-banner-area gallery">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 col-sm-8 col-xs-12">
                            <div className="banner-caption contacttext">
                                <h1 className=""> Gallery </h1>
                                {/* <p> Getting in touch is easy! </p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <nav className="breadcrumbs-area">
                <div className="container-fluid">
                    <ol className="breadcrumb">
                        <li><Link to="/">Home</Link></li>
                        <li>Gallery</li>
                    </ol>
                </div>
            </nav>
            {/* Gallery Tabs */}
            <div className="container pad-40" id="InternalPageArea">
                <div className="row tabStyles">
                    <div className="col-sm-12 col-xs-12">
                        <Tabs>
                            <TabList>
                                <Tab selected={activeTab === 'football'}>Photos</Tab>
                                <Tab selected={activeTab === 'cricket'}>Press release</Tab>
                            </TabList>
                            <TabPanel>
                                <GalleryTab items={footballGallery} />
                            </TabPanel>
                            <TabPanel>
                                <GalleryTab items={cricketGallery} />
                            </TabPanel>
                        </Tabs>`

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Gallery;